import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
  Box,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  MenuItem,
} from '@material-ui/core';
import { useStyles } from './style';
import MultipleSelectChip from '../ChipTextField/MultipleSelectChip';
interface ComplementaryDataStepProps {
  control: any;
  errors: any;
  practicesPhysicalActivity: string;
  previousMedication: string;
}

const ComplementaryDataStep: React.FC<ComplementaryDataStepProps> = ({
  control,
  errors,
  practicesPhysicalActivity,
  previousMedication,
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
    loadOneTrustScript();
  };

  const handleClose = () => {
    setOpen(false);
  };

  const loadOneTrustScript = () => {
    const script = document.createElement('script');
    script.src = "https://privacyportal-cdn.onetrust.com/privacy-notice-scripts/otnotice-1.0.min.js";
    script.charset = "UTF-8";
    script.id = "otprivacy-notice-script";
    script.setAttribute("settings", "eyJjYWxsYmFja1VybCI6Imh0dHBzOi8vZnVuY2lvbmFsLWRzYXIubXkub25ldHJ1c3QuY29tL3JlcXVlc3QvdjEvcHJpdmFjeU5vdGljZXMvc3RhdGVzL3ZpZXdzIn0=");
    document.body.appendChild(script);

    script.onload = () => {
      OneTrust.NoticeApi.Initialized.then(function () {
        OneTrust.NoticeApi.LoadNotices(["https://privacyportal-cdn.onetrust.com/4200e0f4-9141-46dc-863a-4c957253a99a/privacy-notices/2052e851-693d-4ef6-85d8-dc9fb59146f7.json"]);
      });
    };

    return () => {
      document.body.removeChild(script);
    };
  };

  return (
    <>
      <Controller
        name="occupationalStatus"
        control={control}
        rules={{ required: 'Informe ao menos uma ocupação' }}
        render={({ field }) => (
          <TextField
            {...field}
            label="Qual sua ocupação?"
            variant="outlined"
            fullWidth
            select
            className={classes.textField}
            error={!!errors.maritalStatus}
            helperText={errors.maritalStatus ? errors.maritalStatus.message : ''}
          >
            <MenuItem value="Trabalhando">Trabalhando</MenuItem>
            <MenuItem value="Aposentado">Aposentado</MenuItem>
            <MenuItem value="Estudante">Estudante</MenuItem>
            <MenuItem value="Do lar">Do lar</MenuItem>
            <MenuItem value="Desempregado">Desempregado</MenuItem>
          </TextField>
        )}
      />

      <Box mt={2}>
        <MultipleSelectChip className={classes.ContainerFild} control={control} errors={errors} />
      </Box>

      <Box className={classes.columnContainer}>
        <Controller
          name="practicesPhysicalActivity"
          control={control}
          rules={{ required: 'Por favor, selecione uma opção' }}
          render={({ field }) => (
            <FormControl
              component="fieldset"
              className={`${classes.textField} ${classes.formControl}`}
              error={!!errors.practicesPhysicalActivity}
            >
              <FormLabel component="legend" className={classes.formLabel}>
                Pratica atividade física?
              </FormLabel>
              <RadioGroup {...field} className={classes.radioGroupRow}>
                <FormControlLabel value="true" control={<Radio />} label="Sim" />
                <FormControlLabel value="false" control={<Radio />} label="Não" />
              </RadioGroup>
            </FormControl>
          )}
        />

        {practicesPhysicalActivity === 'true' && (
          <Box className={classes.columnContainer} mt={1}>
            <Controller
              name="physicalActivityType"
              control={control}
              rules={{ required: 'Informe quais atividades físicas você pratica' }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Quais atividades físicas você pratica?"
                  variant="outlined"
                  fullWidth
                  select
                  className={classes.textField}
                  error={!!errors.physicalActivityType}
                  helperText={errors.physicalActivityType ? errors.physicalActivityType.message : ''}
                  required
                >
                  <MenuItem value="Caminhada">Caminhada</MenuItem>
                  <MenuItem value="Corrida">Corrida</MenuItem>
                  <MenuItem value="Pilates">Pilates</MenuItem>
                  <MenuItem value="Meditação">Meditação</MenuItem>
                  <MenuItem value="Natação">Natação</MenuItem>
                  <MenuItem value="Musculação">Musculação</MenuItem>
                  <MenuItem value="Hidroginástica">Hidroginástica</MenuItem>
                  <MenuItem value="Yoga">Yoga</MenuItem>
                  <MenuItem value="CrossFit">CrossFit</MenuItem>
                  <MenuItem value="Outros">Outros</MenuItem>
                </TextField>
              )}
            />
          </Box>
        )}

        <Controller
          name="previousMedication"
          control={control}
          rules={{ required: 'Por favor, selecione uma opção' }}
          render={({ field }) => (
            <FormControl
              component="fieldset"
              className={`${classes.textField} ${classes.formControl}`}
              error={!!errors.previousMedication}
            >
              <FormLabel component="legend" className={classes.formLabel}>
                Você utilizou medicamentos para enxaqueca antes do Ajovy?
              </FormLabel>
              <RadioGroup {...field} className={classes.radioGroupRow}>
                <FormControlLabel value="Sim" control={<Radio />} label="Sim" />
                <FormControlLabel value="Não" control={<Radio />} label="Não" />
              </RadioGroup>
            </FormControl>
          )}
        />

        {previousMedication === 'Sim' && (
          <Box className={classes.columnContainer}>
            <Controller
              name="reasonForMigratingToProgramMedication"
              control={control}
              rules={{ required: 'Informe o motivo da migração para Ajovy' }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Qual foi o motivo da migração para Ajovy?"
                  variant="outlined"
                  fullWidth
                  select
                  className={classes.textField}
                  error={!!errors.reasonForMigratingToProgramMedication}
                  helperText={
                    errors.reasonForMigratingToProgramMedication
                      ? errors.reasonForMigratingToProgramMedication.message
                      : ''
                  }
                  required
                >
                  <MenuItem value="Preço do Tratamento">Preço do Tratamento</MenuItem>
                  <MenuItem value="Outros Eventos Adversos">Evento Adverso</MenuItem>
                  <MenuItem value="Burocracia e Distribuição">Dificuldade de Distribuição</MenuItem>
                  <MenuItem value="Ineficácia">Ineficácia do tratamento anterior</MenuItem>
                  <MenuItem value="Decisão Médica">Decisão Médica</MenuItem>
                  <MenuItem value="Decisão do Paciente">Decisão do Paciente</MenuItem>
                  <MenuItem value="Primeiro tratamento">Vou iniciar meu tratamento com medicamento Ajovy (fremanezumabe)</MenuItem>
                </TextField>
              )}
            />
          </Box>
        )}

        <Controller
          name="otherDiseases"
          control={control}
          rules={{ required: 'Por favor, informe se possui outras doenças' }}
          render={({ field }) => (
            <FormControl
              component="fieldset"
              className={`${classes.textField} ${classes.formControl}`}
              error={!!errors.otherDiseases}
            >
              <FormLabel component="legend" className={classes.formLabel}>
                Você possui outras doenças?
              </FormLabel>
              <RadioGroup {...field} className={classes.radioGroupRow}>
                <FormControlLabel value="Sim" control={<Radio />} label="Sim" />
                <FormControlLabel value="Não" control={<Radio />} label="Não" />
              </RadioGroup>
            </FormControl>
          )}
        />

        <Controller
          name="monthlyHeadacheDays"
          control={control}
          rules={{
            required: 'Por favor informe a quantidade de dias de dor de cabeça por mês',
            validate: (value) => (value >= 1 && value <= 30) || 'O número de dias deve estar entre 1 e 30',
          }}
          render={({ field }) => (
            <TextField
              {...field}
              label="Número de dias com dor de cabeça por mês antes do Ajovy"
              variant="outlined"
              fullWidth
              inputProps={{ min: 1, max: 30 }}
              type="number"
              className={classes.textField}
              error={!!errors.monthlyHeadacheDays}
              helperText={
                errors.monthlyHeadacheDays ? errors.monthlyHeadacheDays.message : ''
              }
              required
            />
          )}
        />

        <Box className={classes.columnContainer}>
          <Controller
            name="acceptProgramTerms"
            control={control}
            rules={{ required: 'Você deve aceitar o termo de consentimento' }}
            render={({ field }) => (
              <FormControl
                component="fieldset"
                className={`${classes.textField} ${classes.formControl}`}
                error={!!errors.acceptProgramTerms}
              >
                <FormControlLabel
                  control={<Checkbox {...field} />}
                  label={
                    <span>
                      Eu li e aceito o{' '}
                      <a href="#" onClick={handleClickOpen}>
                        termo
                      </a>
                      {' '}de consentimento
                    </span>
                  }
                />
                {errors.acceptProgramTerms && (
                  <TextField
                    error
                    helperText={errors.acceptProgramTerms.message}
                    style={{ display: 'none' }}
                  />
                )}
              </FormControl>
            )}
          />
        </Box>
      </Box>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Termo de Consentimento</DialogTitle>
        <DialogContent>
          <div id="otnotice-2052e851-693d-4ef6-85d8-dc9fb59146f7" className="otnotice"></div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ComplementaryDataStep;